<div class="ion-full-width ion-full-height ion-flex-center-center">
  <ion-spinner color="white" name="crescent"></ion-spinner>
</div>
